export default {
    "created": "Evenimentul webhook a fost creat cu succes",
    "updated": "Evenimentul webhook a fost actualizat cu succes",
    'delivered': 'Evenimentul webhook a fost livrat cu succes',
    "deleted": "Evenimentul webhook a fost șters cu succes",
}
